const MED_PALETTE = [
    { solid: '#ffe566', bg: '#fffbe6', fg: '#854d0e' },
    { solid: '#ef4444', bg: '#fee2e2', fg: '#b91c1c' },
    { solid: '#3b82f6', bg: '#dbeafe', fg: '#1d4ed8' },
    { solid: '#22c55e', bg: '#dcfce7', fg: '#15803d' },
    { solid: '#a855f7', bg: '#f3e8ff', fg: '#7e22ce' },
    { solid: '#ec4899', bg: '#fce7f3', fg: '#be185d' },
    { solid: '#f59e0b', bg: '#fef3c7', fg: '#92400e' },
    { solid: '#06b6d4', bg: '#cffafe', fg: '#0e7490' },
];

export function colorOf(medicationId) {
    const s = String(medicationId);
    let h = 5381;
    for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return MED_PALETTE[Math.abs(h) % MED_PALETTE.length];
}

export function colorOfTime(hour) {
    return MED_PALETTE[((hour % MED_PALETTE.length) + MED_PALETTE.length) % MED_PALETTE.length];
}
